import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { RenameFileDto } from '../../types/vault.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useRenameFile = () => {
  const { mutate: renameFile, isPending } = useIdempotentAppMutation([QueryKey.RENAME_FILE], {
    mutationFn: (
      {
        companyId,
        data,
        fileId,
      }: {
        companyId: string;
        data: RenameFileDto;
        fileId: string;
      },
      { headers },
    ) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'vault', 'files', fileId] },
        {
          body: data,
          headers,
        },
      ),
  });
  return { renameFile, isPending };
};
